export const getColumns = (isKlaReport, prePaidCard, t) => {
  if (isKlaReport) {
    return [
      {
        name: 'collapse',
        hideLabel: true,
        width: 32,
        height: 32,
      },
      {
        name: 'dateAndTime',
        label: t('date_and_time'),
        width: 150,
      },
      {
        name: 'restaurantName',
        label: t('business_name_2'),
        width: 150,
        grow: true,
      },
      {
        name: 'subsidizedMeals',
        label: t('subsidized_meals'),
        width: 150,
      },
      {
        name: 'nettMeals',
        label: t('nett_meals'),
        width: 110,
      },
      {
        name: 'orderType',
        label: t('order_type'),
        width: 105,
      },
      {
        name: 'total',
        label: t('total'),
        width: 80,
        grow: true,
      },
      {
        name: 'menu',
        hideLabel: true,
        width: 30,
      },
    ];
  }
  if (prePaidCard) {
    return [
      {
        name: 'collapse',
        hideLabel: true,
        width: 32,
        height: 32,
      },
      {
        name: 'dateAndTime',
        label: t('date_and_time'),
        width: 170,
      },
      {
        name: 'restaurantName',
        label: t('business_name_2'),
        width: 285,
        grow: true,
      },
      {
        name: 'prepaidBalance',
        label: t('prepaid_balance'),
        width: 110,
      },
      {
        name: 'orderType',
        label: t('order_type'),
        width: 100,
      },
      {
        name: 'total',
        label: t('total'),
        width: 80,
        grow: true,
      },
      {
        name: 'menu',
        hideLabel: true,
        width: 30,
      },
    ];
  }

  return [
    {
      name: 'collapse',
      hideLabel: true,
      width: 32,
      height: 32,
    },
    {
      name: 'dateAndTime',
      label: t('date_and_time'),
      width: 170,
    },
    {
      name: 'restaurantName',
      label: t('business_name_2'),
      width: 300,
      grow: true,
    },
    {
      name: 'orderType',
      label: t('order_type'),
      width: 195,
    },
    {
      name: 'total',
      label: t('total'),
      width: 80,
      grow: true,
    },
    {
      name: 'menu',
      hideLabel: true,
      width: 60,
    },
  ];
};
